import React, { useState } from 'react';
import {
  Modal,
  Box,
  Typography,
  Button,
  IconButton,
  CircularProgress,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { MuiOtpInput } from 'mui-one-time-password-input';

interface OtpModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (otp: string) => void;
  isLoading: boolean;
}

const OtpModal: React.FC<OtpModalProps> = ({ open, onClose, onSubmit, isLoading }) => {
  const [otp, setOtp] = useState<string>('');
  const [error, setError] = useState<string>('');

  const handleSubmit = () => {
    if (otp.length === 5) {
      setOtp('');
      onSubmit(otp);
    } else {
      setError('Por favor, ingresa un OTP de 5 dígitos.');
    }
  };

  return (
    <Modal open={open}  onClose={(event, reason) => {
      if (reason !== 'backdropClick') {
        setOtp('');
        onClose();
      }}}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '80%', sm: '60%', md: '50%', lg: '30%', xl:'25%' },
          bgcolor: 'background.paper',
          borderRadius: '12px',
          boxShadow: 24,
          p: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <IconButton
          sx={{
            position: 'absolute',
            top: 0,
            right: 0,
            color: 'text.primary',
          }}
          onClick={() => {
            setOtp('');
            onClose();
          }}          
        >
          <Close />
        </IconButton>

        <Typography variant="h6" align="center" sx={{ marginBottom: '16px' }}>
          Ingresa el código OTP
        </Typography>

        <MuiOtpInput
          length={5}
          value={otp}
          onChange={(newCode: any) => setOtp(newCode)}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            gap: 3, 
            '& .MuiInputBase-root': {
              width: '100%',
              maxWidth: '50px',
              height: { xs: '50px', sm: '55px', md: '60px' },
              fontSize: { xs: '1rem', sm: '1rem', md: '1.5rem', lg:'1.5rem' },
              borderRadius: '8px',
              border: '1px solid #ccc',
              '&.Mui-focused': {
                borderColor: 'lightblue',
              },
            },
            '& .MuiInputBase-input': {
              textAlign: 'center',
            },
          }}
        />

        {error && (
          <Typography variant="body2" color="error" sx={{ textAlign: 'center', marginTop: 2 }}>
            {error}
          </Typography>
        )}

        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          fullWidth
          sx={{ marginTop: 3, width: '100%'}}
          disabled={isLoading}
        >
          {isLoading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            'Verificar OTP'
          )}
        </Button>
      </Box>
    </Modal>
  );
};

export default OtpModal;
